var finansudd = finansudd || {};

finansudd.curriculalist = new function () {

	var self = this;

	this.initCurricula = function () {
		if ($("#curricula-list").length) {
			self.loadCurricula(1);
			self.getFilter();
		}
	}

	this.getFilter = function () {
		var filters = $(".course-filter");

		filters.on('change', function () {
			self.loadCurricula(1);
		});
	}
	
	this.loadCurricula = function (page) {

		var favorites = [];
		var subjectAreas = [];
		var types = [];
		var targetAudiences = [];
		var sort = $("#course-sort").val();

		var getSubjectAreaValues = $("#filterid-3130").val();
		var getTypesValues = $("#filterid-3151").val();
		var getTargetAudienceValues = $("#filterid-4397").val();


		if (getSubjectAreaValues!=null)
		{
			subjectAreas = getSubjectAreaValues;
		}

		if (subjectAreas == null || subjectAreas == undefined || subjectAreas == "0") {
			subjectAreas = [];
		}

		if (getTypesValues != null) {
			types = getTypesValues;
		}

		if (getTargetAudienceValues != null) {
			targetAudiences = getTargetAudienceValues;
		}

		var filterValues = JSON.stringify({
			"Mode": "list",
			"Favorites": favorites,
			"SubjectAreas": subjectAreas,
			"Types": types,
			"TargetAudiences": targetAudiences,
			"SortOrder": sort,
			"CurrentPageId": 0,
			"DocType": "Curricula",
			//"MaxItems": 12,
			"Page": page
		});

		$.ajax({
			url: "/settings/courseListView/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {
				var itemCount = $(data).siblings('.item-count').text();
				$('.ajax-filter .filter-count > span').html(itemCount);
				
				$("#curricula-list").html(data);
				novicell.responsiveImages.init();
				finansudd.favorites.setFavoritesOnlist();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown);
			}
		});
	}
}